import React from "react";

const EditPrazoModal = ({
  editPrazoData,
  handleEditChange,
  updatePrazo,
  closeEditModal,
}) => {
  return (
    <div
      className="modal fade show"
      id="editModal"
      style={{ display: "block" }}
      role="dialog"
      aria-labelledby="editModalLabel"
      aria-modal="true"
    >
      <div className="modal-dialog" role="document" style={{ marginTop: "70px" }}>
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="editModalLabel">
              Editar Prazo
            </h5>
            <button type="button" className="close" onClick={closeEditModal}>
              <span>&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <label htmlFor="edit_descricao">Descrição</label>
            <textarea
              className="form-control"
              id="edit_descricao"
              name="descricao"
              value={editPrazoData.descricao}
              onChange={handleEditChange}
              rows="3"
            ></textarea>
            <label htmlFor="edit_data">Data</label>
            <input
              type="date"
              className="form-control"
              id="edit_data"
              name="data"
              value={editPrazoData.data}
              onChange={handleEditChange}
            />
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={closeEditModal}
            >
              Fechar
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={updatePrazo}
            >
              Salvar Alterações
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditPrazoModal;
